module.exports = __webpack_public_path__ + "img/imageGalery7.8c33d3d4.jpg";